<template>
  <div class="profile-container">
        <div class="profile-page-container" id="profile-page-container">

            <div class="content-follow-container">
                <!-- mid content section-->
                <div class="content-section-detail">

                    <div class="sub-header articles-section organisation-sub-header">
                        <!--left header part-->
                        <!-- <div class="image-section-detail content-section"> -->
                            <div class="donation-sub-header flex">
                                <i class="nova-donate donate-icon"></i>
                                <h6 class="donation-sub-heading">{{$t('Newsroom Donations')}}</h6>
                            </div>
                        <!-- </div> -->
                    </div>

                    <div style="margin-top: 32px">
                        <router-view :donations="donations" :isFetching="isFetching"></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getEligibleDonations} from '@/libs/api/api'
import donationDetail from '@/components/pages/InformationPortal/Donations/DonationDetail/DonationDetail.vue'
import {mapGetters} from 'vuex'
export default{
    name: 'Organisation',
    components:{
        donationDetail
    },
    data() {
        return {
            isFetching: false,
        }
    },
    computed: {
        ...mapGetters({donations: 'getDonations'})
    },
    async created () {
        try {
            this.isFetching = true
            let response = await getEligibleDonations()
            this.$store.dispatch('setDonations', response)
        } catch (error) {
            console.error(error)
        } finally {
            this.isFetching = false
        }
    }
}
</script>
<style lang="scss">
    @import "@/components/pages/InformationPortal/Donations/DonationList/donationList.scss";
</style>